import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App';
import { BrowserRouter as Router } from 'react-router-dom';
import '@ant-design/v5-patch-for-react-19';
import { ThemeProvider, Theme } from './theme/ThemeProvider';

const container = document.getElementById('root');
const root = createRoot(container!); // TypeScript 用户加 ! 非空断言

// 全局主题配置：Tech=科技风, Business=商务风, Classic=经典风
const GLOBAL_THEME_NAME = Theme.Tech;

root.render(
    <React.StrictMode>
        <ThemeProvider defaultTheme={GLOBAL_THEME_NAME}>
            <Router>
                <App />
            </Router>
        </ThemeProvider>
    </React.StrictMode>,
);
